import { render, staticRenderFns } from "./_template-breadcrumb-header.vue?vue&type=template&id=b88f4946&scoped=true&"
import script from "./_template-breadcrumb-header.vue?vue&type=script&lang=js&"
export * from "./_template-breadcrumb-header.vue?vue&type=script&lang=js&"
import style0 from "./_template-breadcrumb-header.vue?vue&type=style&index=0&id=b88f4946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88f4946",
  null
  
)

export default component.exports